import { useState, useRef, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NotificationBell from './NotificationBell';
import { useCompanyLogo } from '@/hooks/useCompanyLogo';
import LoadingOverlay from '../base/LoadingOverlay';
import AdminBottomNav from './AdminBottomNav';

const HEADER_HEIGHT = 56;

export default function AdminMobileLayout() {
  const location = useLocation();
  const companyLogo = useCompanyLogo();
  const [isNavigating, setIsNavigating] = useState(false);
  const prevPathRef = useRef(location.pathname);
  const mainContentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (location.pathname !== prevPathRef.current) {
      setIsNavigating(true);
      prevPathRef.current = location.pathname;
      const timer = setTimeout(() => setIsNavigating(false), 800);
      return () => clearTimeout(timer);
    }
  }, [location.pathname]);

  // Scroll del contenido hacia arriba al cambiar de ruta
  useEffect(() => {
    if (mainContentRef.current) {
      mainContentRef.current.scrollTop = 0;
    }
  }, [location.pathname]);

  return (
    <>
      {isNavigating && <LoadingOverlay message="Cargando..." />}
      <div className="h-[100dvh] w-full flex flex-col bg-gray-50 overflow-hidden">
        {/* Header */}
        <header
          className="flex-shrink-0 bg-white border-b border-gray-100 flex items-center justify-between z-30"
          style={{
            height: HEADER_HEIGHT + 'px',
            paddingLeft: '1rem',
            paddingRight: '1rem',
            paddingTop: 'env(safe-area-inset-top)',
          }}
        >
          <div className="flex items-center gap-2.5 min-w-0 flex-1">
            <div className="w-8 h-8 flex-shrink-0 flex items-center justify-center bg-gray-50 rounded-lg border border-gray-100">
              <img
                src={companyLogo || 'https://fotosyvideosantarosa.com/storage/2025/12/fyvnueva2.png'}
                alt="Logo"
                className="w-full h-full object-contain"
              />
            </div>
            <h1 className="text-sm font-semibold text-gray-900 truncate">
              Pixory AI
            </h1>
          </div>
          <div className="flex items-center gap-1 flex-shrink-0">
            <NotificationBell />
          </div>
        </header>

        {/* Main content */}
        <main
          ref={mainContentRef}
          className="flex-1 overflow-y-auto min-w-0"
          style={{ paddingBottom: `calc(64px + env(safe-area-inset-bottom, 0px) + 8px)` }}
        >
          <Outlet />
        </main>

        {/* Bottom Navigation */}
        <AdminBottomNav />
      </div>
    </>
  );
}